import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { trackActivity } from './services/api'

window.addEventListener('error', (event) => {
  trackActivity({
    event: 'js_error',
    feature: 'client',
    success: false,
    error: event.message || 'Unknown JS error',
    path: window.location.pathname,
    metadata: { line: String(event.lineno), col: String(event.colno) },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason instanceof Error ? event.reason.message : String(event.reason);
  trackActivity({
    event: 'unhandled_rejection',
    feature: 'client',
    success: false,
    error: reason,
    path: window.location.pathname,
  });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
